import { defineStore } from 'pinia';
export const useGoodsStore = defineStore('__mall_goods_store', {
  state: function () {
    return {
      currentGoods: null,
      payVisible: false,
      payPrice: 0,
      discountPrice: 0
    };
  },
  actions: {
    setCurrentGoods(currentGoods) {
      this.currentGoods = currentGoods;
      this.payPrice = currentGoods ? currentGoods.sku_real_price : 0;
      this.discountPrice = currentGoods ? currentGoods.sku_discount_price || currentGoods.sku_price : 0;
    },
    setPayVisible(visible) {
      this.payVisible = visible;
    }
  }
});